import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';

import store, { history } from './store';
import './index.less';
import Routes from './routes';
import ScrollToTop from './components/ScrollToTop';
import reportWebVitals from './reportWebVitals';

const darkPrimary = '#091622';
const colorPrimary = '#003366';
const colorLink = '#0088FF';
const colorWhite = '#FFFFFF';
const colorStrokeField = '#D9D9D9';

const theme = {
	token: {
		colorPrimary,
		colorLink,

		// Custom Colors
		colorDarkPrimary: darkPrimary,
		colorWhite,
		colorStrokeField
	},
	components: {
		Layout: {
			siderBg: darkPrimary
		},
		Menu: {
			darkItemSelectedBg: colorLink,
			itemHeight: 58
		},
		Button: {
			primaryShadow: null
		},
		Input: {
			activeShadow: null
		}
	}
};


ReactDOM.render(
	<React.StrictMode>
		<Provider store={store()}>
			<ConnectedRouter history={history}>
				<ConfigProvider theme={theme}>
					<ScrollToTop />
					<Routes />
				</ConfigProvider>
			</ConnectedRouter>
		</Provider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
